import { RowState } from "../models/enums";

declare global {
  interface String {
    toAddPrefix(prefix: string): string;
  }
  interface Array<T> {
    isValid(): boolean;
  }
  interface Array<T> {
    getSumWithKey(prop: string): number;
  }
  interface Array<T> {
    getMaxWithKey(prop: string): number;
  }
  interface Array<T> {
    getMinWithKey(prop: string): number;
  }
  interface Map<K, V> {
    SetInArray<V>(this: Map<K, V[]>, key: K, value: V): boolean;
  }
  interface Object {
    CustomMap(input: any, output: any, isArray?: boolean): any;
  }
}
Object.defineProperty(Array.prototype, "getSumWithKey", {
  value: function (key: string): number {
    if (this.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length <= 0) return 0;
    return this.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).reduce(
      (s: number, b: number) => (s ?? 0) + (b[key] ?? 0),
      0
    );
  },
});
Object.defineProperty(Array.prototype, "getMaxWithKey", {
  value: function (key: string): number {
    if (this.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length <= 0) return 0;
    return Math.max(...this.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).map((o) => o[key]));
  },
});

Object.defineProperty(Array.prototype, "getMinWithKey", {
  value: function (key: string): number {
    if (this.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length <= 0) return 0;
    return Math.min(...this.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).map((o) => o[key]));
  },
});
Object.defineProperty(String.prototype, "toAddPrefix", {
  value: function (prefixStr: string): string {
    return `${prefixStr}${this}`;
  },
});
Object.defineProperty(Map.prototype, "SetInArray", {
  value: function <K, V>(this: Map<K, V[]>, key: K, value: V): boolean {
    let isNew = false;
    if (this.has(key) === false) {
      this.set(key, []);
      isNew = true;
    }
    const items: V[] = this.get(key);
    items.push(value);
    return isNew;
  },
});
Object.defineProperty(Object.prototype, "CustomMap", {
  value: function <K, V>(input: any, output: any, isArray = false): any {
    //var destination_model = new T();
    if (!isArray) {
      if (!output || !input || typeof input !== "object") {
        return;
      }
      const destination = Object.keys(output);
      const source = Object.keys(input);
      source.forEach((key) => {
        if (destination.some((el) => el === key)) {
          output[key] = input[key];
        }
      });
      return output;
    } else {
      if (!output || !input || typeof input !== "object") {
        return;
      }
      const arr = [];
      const destination = Object.keys(output);
      const source = Object.keys(this[0]);
      this.forEach((item) => {
        const obj = JSON.parse(JSON.stringify(output));
        source.forEach((key) => {
          if (destination.some((el) => el === key)) {
            obj[key] = item[key];
          }
        });
        arr.push(obj);
      });
      return arr;
    }
  },
});

export {};
